import { Component, type ErrorInfo, type ReactNode } from 'react';
import { useT } from '../lib/i18n.js';
import { reloadOnceForStaleChunk } from '../lib/chunkRecovery.js';

/** Auch ein unerwarteter Seitenfehler bekommt einen sichtbaren Rückweg. */
export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Veralteter Seitenbaustein nach einem Deploy: einmal still neu laden statt Fehlerseite.
    if (reloadOnceForStaleChunk(String(error?.message ?? ''))) return;
    console.error('AI Feed Factory: Seitenfehler', error, info.componentStack);
  }

  render() { return this.state.failed ? <Failure /> : this.props.children; }
}

function Failure() {
  const t = useT();
  return <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
    <section className="card card-pad col" role="alert" style={{ maxWidth: 480, gap: 16 }}>
      <h1>{t('Diese Seite konnte nicht geladen werden.')}</h1>
      <p className="dim">{t('Lade die Seite neu oder kehre zu deinen Projekten zurück.')}</p>
      <div className="row wrap">
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>{t('Seite neu laden')}</button>
        <a className="btn btn-secondary" href="/">{t('Alle Projekte')}</a>
      </div>
    </section>
  </main>;
}
